import styled from 'styled-components'

import { BREAKPOINT } from '../../constants'

export const Container = styled.div`
  padding: 32px 16px 16px;

  @media(min-width: ${BREAKPOINT.lg}) {
    padding: 32px;
  }
`

export const BrandContainer = styled.div`
  max-width: 250px;
  margin: 0 auto 32px;
`

export const HeaderContainer = styled.div`
  text-align: center;
  margin-bottom: 30px;

  span:last-child {
    display: block;
    margin-top: 16px;
  }
`

export const FooterContainer = styled.div`
  text-align: center;
  margin-bottom: 10px;

  span {
    display: block;
  }
`

export const FormContainer = styled.div`
  margin-bottom: 20px;

  select {
    &:invalid,
    &[value=""] {
      color: #767BA7;
      opacity: 0.7;
    }

    &:valid {
      color: inherit;
      opacity: 1;
    }

    option:first-child {
      color: #767BA7;
    }

    option:not(:first-child) {
      color: #000;
    }
  }

  input:disabled {
    color: #767BA7;
    font-size: 14px;
    line-height: 20px;
  }

  input:not(:disabled)::placeholder {
    color: #767BA7;
    font-size: 16px;
    line-height: 22px;
  }

  input[type="password"] {
    letter-spacing: 0.3em;
  }

  span[class*="Message"],
  span[class*="Helper"],
  small {
    white-space: pre-line;
  }
`

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
`

export const SubmitSpinner = styled.div`
  animation: spin 1s linear infinite;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  border-top-color: #FFFFFF;
  height: 20px;
  margin: 0 auto;
  width: 20px;

  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
`

export const SetupWrapper = styled.div`
  background-color: #091539;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  padding: 40px 16px;

  > div {
    width: 100%;
    max-width: 600px;
  }
`

export const IconContainer = styled.div`
  margin-bottom: 24px;
  display: flex;
  justify-content: center;
`
